/* eslint-disable sonarjs/no-duplicate-string */
// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_ADD_EDIT_ADDRESS_LABELS = 'global.addEditAddress';

export const lblAddEditAddressEditAddress = 'lbl_addEditAddress_editAddress';
export const lblAddEditAddressAddAddress = 'lbl_addEditAddress_addAddress';
export const lblAddEditAddressAddressLine1 = 'lbl_addEditAddress_addressLine1';
export const lblAddEditAddressAddressLine2 = 'lbl_addEditAddress_addressLine2';
export const lblAddEditAddressCity = 'lbl_addEditAddress_city';
export const lblAddEditAddressState = 'lbl_addEditAddress_state';
export const lblAddEditAddressProvince = 'lbl_addEditAddress_province';
export const lblAddEditAddressPostalCode = 'lbl_addEditAddress_postalCode';
export const lblAddEditAddressCountry = 'lbl_addEditAddress_country';
export const lblAddEditAddressSetDefault = 'lbl_addEditAddress_setDefault';
export const lblAddEditAddressAddressButton = 'lbl_addEditAddress_addressButton';
export const lblAddEditAddressErrorMessageAE09 = 'lbl_addEditAddress_errorMessageAE09';
export const lblAddEditAddressErrorMessageAE10 = 'lbl_addEditAddress_errorMessageAE10';
export const lblAddEditAddressErrorMessageAE11 = 'lbl_addEditAddress_errorMessageAE11';
export const lblAddEditAddressErrorMessageAE12 = 'lbl_addEditAddress_errorMessageAE12';
export const lblAddEditAddressErrorMessageDefault = 'lbl_addEditAddress_errorMessageDEFAULT';
export const lblAddEditAddressEntered = 'lbl_addEditAddress_entered';
export const lblAddEditAddressSuggest = 'lbl_addEditAddress_suggest';
export const lblAddEditAddressVerifyHeader = 'lbl_addEditAddress_verifyHeader';
export const lblAddEditAddressContinueCta = 'lbl_addEditAddress_continueCta';
export const lblAddEditAddressInternationalShipping = 'lbl_addEditAddress_internationalShipping';
export const lblAddEditAddressErrorZipCode = 'lbl_addEditAddress_error_zipCode';
export const lblAddEditAddressError = 'lbl_addEditAddress_error';
export const lblAddEditAddressSelect = 'lbl_addEditAddress_select';
export const lblAddEditAddressEmail = 'lbl_addEditAddress_email';
export const lblAddEditAddressSelectFromAddress = 'lbl_addEditAddress_selectFromAddress';
export const lblAddEditAddressAddNewAddress = 'lbl_addEditAddress_addNewAddress';
export const lblAddEditAddressVerifyErrorsFormGeneric =
  'lbl_addEditAddress_verifyErrorsFormGeneric';
export const lblAddEditAddressVerifyErrorsZipCode = 'lbl_addEditAddress_verifyErrorsZipCode';
export const lblAddEditAddressVerifyErrorsCity = 'lbl_addEditAddress_verifyErrorsCity';
export const lblAddEditAddressVerifyErrorsState = 'lbl_addEditAddress_verifyErrorsState';
export const lblAddEditAddressVerifyErrorsAddressLine =
  'lbl_addEditAddress_verifyErrorsAddressLine';
export const lblAddEditAddressVerifyErrorsModalSubPremise =
  'lbl_addEditAddress_verifyErrorsModalSubPremise';
export const lblAddEditAddressVerifyUseUnverifiedBtn = 'lbl_addEditAddress_verifyUseUnverifiedBtn';
export const lblAddEditAddressVerifyErrorsAddressLine2 =
  'lbl_addEditAddress_verifyErrorsAddressLine2';
export const lblAddEditAddressVerifyMappingAE02 = 'lbl_addEditAddress_verifyMappingAE02';
export const lblAddEditAddressVerifyMappingAE07 = 'lbl_addEditAddress_verifyMappingAE07';
export const lblAddEditAddressVerifyMappingAE10 = 'lbl_addEditAddress_verifyMappingAE10';
export const lblAddEditAddressVerifyMappingAE12 = 'lbl_addEditAddress_verifyMappingAE12';
export const lblAddEditAddressVerifyMappingAE13 = 'lbl_addEditAddress_verifyMappingAE13';
export const lblAddEditAddressVerifyMappingAE14 = 'lbl_addEditAddress_verifyMappingAE14';
export const lblAddEditAddressVerifyMappingAE01 = 'lbl_addEditAddress_verifyMappingAE01';
export const lblAddEditAddressVerifyMappingAE11 = 'lbl_addEditAddress_verifyMappingAE11';
export const lblAddEditAddressVerifyMappingAE08 = 'lbl_addEditAddress_verifyMappingAE08';
export const lblAddEditAddressVerifyMappingAE03 = 'lbl_addEditAddress_verifyMappingAE03';
export const lblAddEditAddressVerifyAddressLine2 = 'lbl_addEditAddress_verifyAddressLine2';
export const lblAddEditFindYourAddress = 'lbl_addEdit_findYourAddress';
export const lblAddEditDontSeeYourAddress = 'lbl_addEdit_dontSeeYourAddress';
export const lblAddEditEnterAddressManually = 'lbl_addEdit_enterAddressManually';
export const lblAddEditEnterManually = 'lbl_addEdit_enterManually';
export const lblAddEditAddressShippingAddress = 'lbl_addEditAddress_shippingAddress';
export const lblAddEditAddressSaveAndContinue = 'lbl_addEditAddress_saveAndContinue';
export const lblAddEditAddressAddressLine2Label = 'lbl_addEditAddress_addressLine2Label';
export const lblAddEditAddressSelectFromAddressBook = 'lbl_addEditAddress_selectFromAddressBook';
export const lblAddEditAddressAddNewBtn = 'lbl_addEditAddress_addNew_btn';
export const lblAddEditAddressRegAddNewAddress = 'lbl_addEditAddress_regAddNewAddress';
export const lblAddEditAddressRegEditAddress = 'lbl_addEditAddress_regEditAddress';
export const lblAddEditAddressAddressBook = 'lbl_addEditAddress_addressBook';
export const lblButtonSave = 'lbl_button_save';
export const lblChangeShippingAddress = 'lbl_change_shipping_address';
export const lblAddEditAddressInvalidApartmentNumber =
  'lbl_addEditAddress_invalid_apartment_number';

export default {
  global: {
    addEditAddress: {
      referred: [],
      [lblAddEditAddressEditAddress]: 'EDIT ADDRESS',
      [lblAddEditAddressAddAddress]: 'Add Address',
      [lblAddEditAddressAddressLine1]: 'Address Line 1',
      [lblAddEditAddressAddressLine2]: 'Address Line 2 (Optional)',
      [lblAddEditAddressCity]: 'City',
      [lblAddEditAddressState]: 'State',
      [lblAddEditAddressProvince]: 'Province',
      [lblAddEditAddressPostalCode]: 'Postal Code',
      [lblAddEditAddressCountry]: 'Country',
      [lblAddEditAddressSetDefault]: 'Set as default shipping address',
      [lblAddEditAddressAddressButton]: 'ADD ADDRESS',
      [lblAddEditAddressErrorMessageAE09]:
        'There may be an issue with your address as entered. Please double check it, or if you believe the address is correct you can continue to the next step.',
      [lblAddEditAddressErrorMessageAE10]:
        'The house / building number is missing from your address. Please review and confirm your address.',
      [lblAddEditAddressErrorMessageAE11]:
        'The house / building number is not valid. Please review and confirm your address.',
      [lblAddEditAddressErrorMessageAE12]:
        'The house / building number is not valid. Please review and confirm your address.',
      [lblAddEditAddressErrorMessageDefault]:
        'There may be an issue with your address as entered. Please double check it, or select from the below.',
      [lblAddEditAddressEntered]: 'YOU ENTERED',
      [lblAddEditAddressSuggest]: 'WE SUGGEST',
      [lblAddEditAddressVerifyHeader]: 'Verify Your Address',
      [lblAddEditAddressContinueCta]: 'CONTINUE',
      [lblAddEditAddressInternationalShipping]: 'Shipping internationally?',
      [lblAddEditAddressErrorZipCode]: 'There was a missing parameter: zipCode',
      [lblAddEditAddressError]: 'An error occured, please try again',
      [lblAddEditAddressSelect]: 'Select',
      [lblAddEditAddressEmail]: 'Email',
      [lblAddEditAddressSelectFromAddress]: 'Address book',
      [lblAddEditAddressAddNewAddress]: '+ Add New Address',
      [lblAddEditAddressVerifyErrorsFormGeneric]:
        "We don't recognize the address you provided. Please verify that the information is correct to avoid any delivery delays. ",
      [lblAddEditAddressVerifyErrorsZipCode]: 'Please enter valid Zip',
      [lblAddEditAddressVerifyErrorsCity]: 'Please enter valid City',
      [lblAddEditAddressVerifyErrorsState]: 'Please enter valid State',
      [lblAddEditAddressVerifyErrorsAddressLine]: 'Please enter valid Address Line 1',
      [lblAddEditAddressVerifyErrorsModalSubPremise]:
        'Are you missing an apartment or suite number? Please verify the information to avoid any delivery delays.',
      [lblAddEditAddressVerifyUseUnverifiedBtn]: 'Use Unverified Address',
      [lblAddEditAddressVerifyErrorsAddressLine2]: 'Please enter apartment or suite number',
      [lblAddEditAddressVerifyMappingAE02]:
        "<style> .msg-unverified{font-size: 14px;margin-left:14px; font-weight:600;}.using-unverified{margin-top:10px; } </style> <div class='msg-unverified'>The U.S Postal Service doesn't recognize this address <br/><p class='using-unverified'>Using an unverified address may cause shipment delays.<p></div>",
      [lblAddEditAddressVerifyMappingAE07]:
        "<style> .msg-unverified{font-size: 14px;margin-left:14px; font-weight:600;}.using-unverified{margin-top:10px; } </style> <div class='msg-unverified'>The U.S Postal Service doesn't recognize this address <br/><p class='using-unverified'>Using an unverified address may cause shipment delays.<p></div>",
      [lblAddEditAddressVerifyMappingAE10]:
        "<style> .msg-unverified{font-size: 14px;margin-left:14px; font-weight:600;}.using-unverified{margin-top:10px; } </style> <div class='msg-unverified'>The U.S Postal Service doesn't recognize this address <br/><p class='using-unverified'>Using an unverified address may cause shipment delays.<p></div>",
      [lblAddEditAddressVerifyMappingAE12]:
        "<style> .msg-unverified{font-size: 14px;margin-left:14px; font-weight:600;}.using-unverified{margin-top:10px; } </style> <div class='msg-unverified'>The U.S Postal Service doesn't recognize this address <br/><p class='using-unverified'>Using an unverified address may cause shipment delays.<p></div>",
      [lblAddEditAddressVerifyMappingAE13]:
        "<style> .msg-unverified{font-size: 14px;margin-left:14px; font-weight:600;}.using-unverified{margin-top:10px; } </style> <div class='msg-unverified'>The U.S Postal Service doesn't recognize this address <br/><p class='using-unverified'>Using an unverified address may cause shipment delays.<p></div>",
      [lblAddEditAddressVerifyMappingAE14]:
        "<style> .msg-unverified{font-size: 14px;margin-left:14px; font-weight:600;}.using-unverified{margin-top:10px; } </style> <div class='msg-unverified'>The U.S Postal Service doesn't recognize this address <br/><p class='using-unverified'>Using an unverified address may cause shipment delays.<p></div>",
      [lblAddEditAddressVerifyMappingAE01]:
        'Please check your City, State or Zip/Postal Code. Using an unverified address may cause delays ',
      [lblAddEditAddressVerifyMappingAE11]:
        'Please check your Address Line 1. Using an unverified address may cause delays ',
      [lblAddEditAddressVerifyMappingAE08]:
        'Please check your Apartment/Suite number. Using an unverified address may cause delays ',
      [lblAddEditAddressVerifyMappingAE03]:
        "<style> .msg-unverified{font-size: 14px;margin-left:14px; font-weight:600;}.using-unverified{margin-top:10px; } </style> <div class='msg-unverified'>The U.S Postal Service doesn't recognize this address <br/><p class='using-unverified'>Using an unverified address may cause shipment delays.<p></div>",
      [lblAddEditAddressVerifyAddressLine2]: 'Apartment or suite number',
      [lblAddEditFindYourAddress]: 'Find your address',
      [lblAddEditDontSeeYourAddress]: "Don't see your address?",
      [lblAddEditEnterAddressManually]: 'Enter address manually',
      [lblAddEditEnterManually]: 'Enter manually',
      [lblAddEditAddressShippingAddress]: 'Shipping Address',
      [lblAddEditAddressSaveAndContinue]: 'SAVE & CONTINUE',
      [lblAddEditAddressAddressLine2Label]: 'Address Line 2',
      [lblAddEditAddressSelectFromAddressBook]: 'Select From Address Book',
      [lblAddEditAddressAddNewBtn]: 'Add New',
      [lblAddEditAddressRegAddNewAddress]: 'Add New Address',
      [lblAddEditAddressRegEditAddress]: 'Edit Address',
      [lblAddEditAddressAddressBook]: 'Address Book',
      [lblButtonSave]: 'SAVE',
      [lblChangeShippingAddress]: 'Change Shipping Address',
      [lblAddEditAddressInvalidApartmentNumber]: 'Please enter a valid apartment number.',
    },
  },
};
